<template>
  <div class="landing-page sub-page">
    <div class="login-content">
      <div class="login login-send">
        <button class="back-button" type="button" @click="back">
          <img src="../../static/images/back.png" alt="Back">
        </button>
        <div class="logo-wrap"><img src="../../static/images/logo.png" alt="Bottle Pop"></div>
        <div class="middle"><img src="../../static/images/login_pic1.png" alt="Bottle Pop"></div>

        <div class="plan-overlay">
          <div class="mobile-display" aria-label="Phone number">
            <input class="input" v-model="mobile" disabled aria-label="Phone number">
          </div>
          <div class="plan-group">
            <div v-if="showDaily" class="plan-row plan-row--daily">
              <button class="plan-button"
                      :class="{ 'plan-button--daily': !isSinglePlan, 'plan-button--single': isSinglePlan }"
                      type="button" @click="openOtpDialog('daily')">
                <span class="plan-face day-en"><span class="btn-text">{{ $t('Daily') }}</span></span>
              </button>
            </div>
            <div v-if="showWeekly || showMonthly" class="plan-row plan-row--secondary">
              <button v-if="showWeekly"
                      class="plan-button"
                      :class="{ 'plan-button--secondary': !isSinglePlan, 'plan-button--single': isSinglePlan }"
                      type="button" @click="openOtpDialog('weekly')">
                <span class="plan-face week-en"><span class="btn-text">{{ $t('Weekly') }}</span></span>
              </button>
              <button v-if="showMonthly"
                      class="plan-button"
                      :class="{ 'plan-button--secondary': !isSinglePlan, 'plan-button--single': isSinglePlan }"
                      type="button" @click="openOtpDialog('monthly')">
                <span class="plan-face month-en"><span class="btn-text">{{ $t('Monthly') }}</span></span>
              </button>
            </div>
          </div>
        </div>
        <div class="sub-footer">
          <div class="footer-link" @click="getChange('termsAndCondition')">{{ $t('TC') }}</div>
          <div class="footer-link" @click="getChange('faq')">{{ $t('FAQ') }}</div>
        </div>
      </div>
    </div>

    <Dialog ref="otpDialog" type="alert" title="" width="90" :modalFoot="false" :iscloseMask="true"
            style="min-height: 300px;">
      <div class="otp-modal" slot="mdBox">
        <div class="otp-modal__close" @click="closeOtpDialog">
          <img width="70" src="../../static/images/close.png"/>
        </div>

        <div class="otp-modal__title">
          {{ $t('otpTips')  }}
        </div>

        <div class="otp-modal__row">
          <div class="otp-modal__input-wrap">
            <input class="otp-modal__input"
                   v-model="otp"
                   ref="otpInput"
                   maxlength="6"
                   type="tel"
                   inputmode="numeric"
                   pattern="[0-9]*"
                   placeholder=""
                   @input="handleOtpInput"
                   aria-label="OTP">
          </div>
          <button class="otp-modal__resend"
                  type="button"
                  :disabled="isResendDisabled"
                  @click="doSubSendOtp">
            {{ codeText }}
          </button>
        </div>
        <button class="otp-modal__subscribe"
                type="button"
                :disabled="isVerifying"
                @click="doSubVerifyOtp">
          {{ $t('Subscribe')}}
        </button>
      </div>
    </Dialog>
  </div>
</template>

<script>
import Dialog from '../components/dialog.vue'
import CryptoJS from '../../static/js/crypto-js.min.js'

export default {
  components: {Dialog},
  data() {
    return {
      mobile: '',
      showDaily: true,
      showWeekly: true,
      showMonthly: true,
      currentPlanType: '',
      otp: '',
      isSendingOtp: false,
      isVerifying: false,
      codeText: '',
      codeTimer: null
    }
  },
  computed: {
    isSinglePlan() {
      return Number(this.showDaily) + Number(this.showWeekly) + Number(this.showMonthly) === 1
    },
    isResendDisabled() {
      return this.isSendingOtp || this.codeText !== this.$t('getCode')
    }
  },
  created() {
    this.codeText = this.$t('getCode')
    let login_mobile = sessionStorage.getItem('login_mobile') || '';
    if (login_mobile) {
      this.mobile = this.dealPhone_2(login_mobile)
    }
    const type = this.$route.query.type
    if (type === 'daily') this.showOnly('daily')
    else if (type === 'weekly') this.showOnly('weekly')
    else if (type === 'monthly' || type === 'month') this.showOnly('monthly')
  },
  beforeDestroy() {
    if (this.codeTimer) {
      clearTimeout(this.codeTimer)
      this.codeTimer = null
    }
  },
  methods: {
    showOnly(type) {
      this.showDaily = type === 'daily'
      this.showWeekly = type === 'weekly'
      this.showMonthly = type === 'monthly'
    },
    back() {
      this.$router.push({path: '/'})
    },
    getChange(type) {
      this.$router.push({path: '/' + type})
    },
    handleOtpInput(e) {
      this.otp = (e.target.value || '').replace(/\D/g, '')
    },
    openOtpDialog(type) {
      if (this.mobile === '') {
        this.$utils.alertText(this.$t('loginTips'), 60)
        return
      }
      this.currentPlanType = type
      this.otp = ''
      this.codeText = this.$t('getCode')
      this.$refs.otpDialog.showMaskFun()
      this.$nextTick(() => {
        if (this.$refs.otpInput) this.$refs.otpInput.focus()
      })
      this.doSubSendOtp()
    },
    closeOtpDialog() {
      if (this.codeTimer) {
        clearTimeout(this.codeTimer)
        this.codeTimer = null
      }
      this.$refs.otpDialog.closeMask()
    },
    doSubSendOtp() {
      const that = this
      if (that.isSendingOtp) return
      if (that.mobile === '') {
        that.$utils.alertText(that.$t('loginTips'), 60)
        return
      }
      that.isSendingOtp = true
      let params = {
        'msidn':that.mobile,
        'subappid':this.currentPlanType,
        'channelId':this.$route.query.channelId?this.$route.query.channelId:"",
        'code':this.$route.query.code?this.$route.query.code:"",
      };
      that.$parent.loadModal(true);
      that.$secureApi.post('/api/user/sub_send_otp', params, r => {
        that.$parent.loadModal(false);
        that.isSendingOtp = false
        that.$utils.alertText(r.msg, 80, 2000);
        if (r.code == 1) {
          that.countDown(61, 1)
        }
      })
    },
    doSubVerifyOtp() {
      const that = this
      if (that.isVerifying) return
      if (that.mobile === '') {
        that.$utils.alertText(that.$t('loginTips'), 60)
        return
      }
      if (!that.otp) {
        that.$utils.alertText(that.$t('enter_otp'), 60)
        return
      }
      that.isVerifying = true
      let params = {
        'msidn':that.mobile,
        'subappid':that.currentPlanType,
        'otp':that.otp,
        'channelId':this.$route.query.channelId?this.$route.query.channelId:"",
        'code':this.$route.query.code?this.$route.query.code:"",
        'device_id': that.getDeviceId()
      };
      that.$parent.loadModal(true);
      that.$secureApi.post('/api/user/sub_verify_otp', params, r => {
        that.$parent.loadModal(false);
        if (r.code == 1) {
          sessionStorage.setItem('login_mobile',that.mobile);
          this.$router.push({path: '/otp'})
        } else {
          that.$utils.alertText(r.msg, 80, 2000);
          that.isVerifying = false
        }
      })
    },
    countDown(miao, type) {
      if (miao === 1) {
        this.codeText = this.$t('getCode');
        return;
      }
      miao--;
      if (type === 1) {
        this.codeText = miao + 's';
      }
      this.codeTimer = setTimeout(() => {
        this.countDown(miao, type);
      }, 1000)
    },
    dealPhone_2(phone) {
      phone = phone.replace(/\s+/g, '')
      if (phone.startsWith('97') && phone.length === 10) phone = phone.substring(1)
      return phone
    },
    dealPhone(phone) {
      phone = phone.replace(/\s+/g, '')
      if (phone.startsWith('0909') && phone.length === 13) phone = phone.substring(3)
      if (phone.startsWith('09') && phone.length === 11) phone = phone.substring(1)
      if (phone.startsWith('099') && phone.length === 12) phone = phone.substring(2)
      return phone
    },
    getDeviceId() {
      let id = localStorage.getItem('device_id')
      if (!id) {
        id = 'dev-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9)
        localStorage.setItem('device_id', id)
      }
      return id
    },

  }
}
</script>

<style scoped>
.sub-page {
  min-height: 100vh;
  background: url(../../static/images/land-bg.png) no-repeat center top;
  background-size: cover !important;
}

.back-button {
  position: absolute;
  top: clamp(14px, 3.2vw, 24px);
  left: clamp(14px, 3.2vw, 24px);
  width: clamp(44px, 8vw, 60px);
  height: clamp(44px, 8vw, 60px);
  padding: 8px;
  border: 0;
  z-index: 4;
  cursor: pointer;
}

.back-button img {
  width: 100%;
  display: block;
}

.logo-wrap {
  width: 100%;
  text-align: center;
}

.logo-wrap img {
  width: 35%;
  margin-top: 50px;
}

.middle img {
  top: clamp(118px, 28vw, 210px) !important;
}

.plan-overlay {
  margin: 220px 40px 0;
  position: relative;
  z-index: 3;
}

.mobile-display {
  width: 86%;
  height: clamp(56px, 12vw, 90px);
  margin: 0 auto clamp(18px, 4vw, 30px);
  padding: 0 clamp(12px, 2.7vw, 20px) 0 clamp(5px, 1.1vw, 8px);
  display: flex;
  align-items: center;
  overflow: hidden;
  background: rgba(15, 52, 31, 0.82);
  border: 0;
  border-radius: 60px;
  box-shadow: inset 0 0 0 3px rgba(164, 255, 217, 0.18);
}

.phone-prefix {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  margin-right: clamp(8px, 1.9vw, 14px);
}

.phone-prefix img {
  width: clamp(66px, 12.7vw, 95px);
  height: auto;
  display: block;
}

.mobile-display input {
  flex: 1;
  min-width: 0;
  height: auto;
  line-height: 1.2;
  margin: 0;
  padding: 0 clamp(14px, 3.2vw, 24px);
  color: #fff;
  font-size: clamp(30px, 6.4vw, 46px) !important;
  font-weight: 700;
  background: transparent;
  border: 0;
  opacity: 1;
  -webkit-text-fill-color: #fff;
}

.plan-group {
  width: 86%;
  margin: 0 auto;
}

.plan-row {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: clamp(10px, 2.4vw, 18px);
}

.plan-row--secondary {
  margin-top: clamp(10px, 2.4vw, 18px);
}

.plan-button {
  min-width: 0;
  padding: 0;
  border: 0;
  cursor: pointer;
}

.plan-button--daily,
.plan-button--single {
  flex: 0 0 auto;
  width: calc((100% - clamp(10px, 2.4vw, 18px)) / 2);
  max-width: 240px;
}

.plan-button--secondary { flex: 1 1 0; }

.plan-face {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: 100% 100% !important;
}

.plan-face .btn-text {
  font-size: clamp(20px, 4vw, 30px);
}

.day-en {
  aspect-ratio: 309 / 162;
  background: url(../../static/images/daily-bg_en.png) no-repeat center !important;
  background-size: 100% 100% !important;
}

.week-en {
  aspect-ratio: 276 / 145;
  background: url(../../static/images/week-bg_en.png) no-repeat center !important;
  background-size: 100% 100% !important;
}

.month-en {
  aspect-ratio: 276 / 145;
  background: url(../../static/images/month-bg_en.png) no-repeat center !important;
  background-size: 100% 100% !important;
}

.sub-footer {
  width: 70%;
  max-width: 520px;
  margin: clamp(24px, 5vw, 40px) auto 0;
  display: flex;
  justify-content: space-between;
  position: relative;
  z-index: 3;
}

.footer-link {
  color: #8b4c12;
  font-size: clamp(18px, 4vw, 30px);
  font-weight: 900;
  white-space: nowrap;
  cursor: pointer;
}

.otp-modal {
  position: relative;
  overflow: hidden;
  background: linear-gradient(165deg, rgba(43, 111, 56, 0.98) 0%, rgba(11, 57, 34, 0.99) 100%);
  border: 3px solid #fff1b3;
  border-radius: 30px;
  padding: clamp(20px, 5vw, 36px) clamp(20px, 5vw, 36px) clamp(28px, 6vw, 44px);
  box-sizing: border-box;
  box-shadow: 0 18px 0 rgba(91, 57, 18, 0.38), 0 26px 56px rgba(27, 56, 21, 0.45), inset 0 0 0 3px rgba(255, 226, 112, 0.22);
  color: #fff;
}

.otp-modal__close {
  text-align: right;
  margin: -8px -12px 4px auto;
  cursor: pointer;
  line-height: 0;
}

.otp-modal__close img {
  width: clamp(42px, 9vw, 58px) !important;
}

.otp-modal__title {
  text-align: center;
  font-weight: 900;
  color: #fff9d7;
  font-size: clamp(22px, 4.8vw, 34px);
  line-height: 1.2;
  margin: 6px 0 clamp(16px, 3.8vw, 28px);
  letter-spacing: 0.4px;
  text-shadow: 0 3px 0 rgba(44, 74, 22, 0.72);
}

.otp-modal__row {
  display: flex;
  align-items: stretch;
  gap: clamp(10px, 2.2vw, 16px);
  padding: clamp(8px, 1.9vw, 14px);
  border: 2px solid rgba(255, 231, 145, 0.68);
  background: rgba(5, 42, 25, 0.4);
  border-radius: 22px;
  margin-bottom: clamp(20px, 4.5vw, 32px);
}

.otp-modal__input-wrap {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, #fffdf2 0%, #f6eecb 100%);
  border: 2px solid rgba(255, 255, 255, 0.9);
  border-radius: 16px;
  box-shadow: inset 0 2px 0 rgba(255, 255, 255, 0.88), 0 5px 0 rgba(69, 89, 33, 0.35);
  overflow: hidden;
}

.otp-modal__input {
  width: 100%;
  height: clamp(68px, 14.5vw, 108px);
  text-align: center;
  letter-spacing: clamp(8px, 2vw, 18px);
  font-weight: 800;
  font-size: clamp(30px, 6.6vw, 48px);
  color: #315327;
  border: 0;
  outline: none;
  background: transparent;
  padding: 0 clamp(12px, 2.6vw, 20px);
  box-sizing: border-box;
  border-radius: 16px;
}

.otp-modal__input::placeholder {
  color: rgba(49, 83, 39, 0.35);
  letter-spacing: 0;
  font-weight: 600;
  font-size: clamp(20px, 4.2vw, 30px);
}

.otp-modal__resend {
  flex: 0 0 auto;
  min-width: clamp(100px, 23vw, 158px);
  padding: 0 clamp(14px, 3vw, 22px);
  background: linear-gradient(180deg, #ffd957 0%, #f69b16 100%);
  color: #5d2c0d;
  border: 2px solid #fff6c3;
  border-radius: 16px;
  font-weight: 800;
  font-size: clamp(18px, 4vw, 28px);
  cursor: pointer;
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.52);
  box-shadow: 0 5px 0 #b7620b, 0 10px 20px rgba(32, 39, 9, 0.24), inset 0 2px 0 rgba(255, 255, 255, 0.48);
  transition: transform 0.08s ease;
}

.otp-modal__resend:active {
  transform: translateY(1px);
}

.otp-modal__resend:disabled {
  background: linear-gradient(180deg, #f7dc8a 0%, #dcad59 100%);
  box-shadow: 0 4px 0 #a77b3c;
  color: rgba(93, 44, 13, 0.78);
  cursor: not-allowed;
}

.otp-modal__subscribe {
  display: block;
  width: min(280px, 68vw);
  aspect-ratio: 309 / 162;
  margin: 0 auto;
  padding: 0;
  border: 0;
  background: url(../../static/images/daily-bg_en.png) no-repeat center;
  background-size: 100% 100%;
  color: #fff;
  font-weight: 900;
  font-size: clamp(22px, 4.8vw, 34px);
  letter-spacing: 0.8px;
  cursor: pointer;
  text-shadow: -2px -2px 0 #63208a, 2px -2px 0 #63208a, -2px 2px 0 #63208a, 2px 2px 0 #63208a;
  filter: drop-shadow(0 8px 10px rgba(32, 39, 9, 0.34));
  transition: transform 0.08s ease;
}

.otp-modal__subscribe:active {
  transform: translateY(1px);
}

.otp-modal__subscribe:disabled {
  filter: grayscale(0.35) brightness(0.86);
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/page/sub.vue